import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border/30"
    >
      <div className="container mx-auto px-6 h-16 flex items-center justify-between">
        <motion.div 
          className="flex items-center gap-3"
          whileHover={{ scale: 1.02 }}
        >
          <img src="/ll-mark-256.png" alt="LegacyLens AI" className="h-10 w-auto" />
          <span className="font-display text-xl font-semibold text-foreground">
            LegacyLens <span className="text-primary">AI</span>
          </span>
        </motion.div>

        <nav className="hidden md:flex items-center gap-8">
          <a
            href="#how-it-works"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            How It Works
          </a>
          <Link to="/partner" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Partner
          </Link>
          <Link to="/tribute/syrus-demo" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            View Demo
          </Link>
          <Link to="/digital-legacy-directive" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            The Directive
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <Button variant="ghost" size="sm" className="hidden sm:inline-flex" asChild>
            <Link to="/login">Sign In</Link>
          </Button>
          <Button variant="hero" size="sm" asChild>
            <Link to="/get-started">Get Started</Link>
          </Button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
